import request from './adminRequest'

export const tagApi = {
  listTag (params) {
    return request.get('/tags', { params: params })
  },
  getTag (id) {
    return request.get('/tags/' + id)
  },
  saveTag (data) {
    return request.post('/tags', data)
  },
  updateTag (id, data) {
    return request.put('/tags/' + id, data)
  },
  deleteTag (id) {
    return request.delete('/tags/' + id)
  },
}
export default tagApi
